import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlogModule } from './pages/blog/blog.module';
import { AmbientalTareaDeTodosModule } from './pages/ambiental-tarea-de-todos/ambiental-tarea-de-todos.component.module';
import { HomeComponent } from './pages/home/home.component';


const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },{
    path:'nosotros',
    loadChildren:()=> import ('./pages/about/about.module').then(m=>m.AboutModule)
  },{
    path:'solucion',
    loadChildren:()=> import ('./pages/solution/solution.module').then(m=>m.SolutionModule)
  },
  {
    path:'libro-de-reclamaciones',
    loadChildren:()=> import ('./pages/reclamaciones/reclamaciones.module').then(m=>m.ReclamacionesModule)
  }
  ,{
    path:'aplicaciones',
    loadChildren:()=> import ('./pages/apply/apply.module').then(m=>m.ApplyModule)
  },{
    path:'proyectos',
    loadChildren:()=> import ('./pages/projects/projects.module').then(m=>m.ProjectsModule)
  },{
    path:'contacto',
    loadChildren:()=> import ('./pages/contact/contact.module').then(m=>m.ContactModule)
  },{
    path:'reportes',
    loadChildren:()=> import ('./pages/blog/blog.module').then(m=>m.BlogModule)
  },{
    path:'la-educacion-ambiental-es-tarea-de-todos',
    loadChildren:()=> import ('./pages/ambiental-tarea-de-todos/ambiental-tarea-de-todos.component.module').then(m=>m.AmbientalTareaDeTodosModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
